import React, {
  ReactElement,
  useState,
  useContext,
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
  PropsWithChildren,
} from 'react';
import { LOCAL_STORAGE_SERVICE_ENTRY } from 'constants/local-storage';
import { getItem, setItem } from 'helpers/local-storage';

interface UseServiceEntry {
  parkId: number;
  date: string;
  setParkId: Dispatch<SetStateAction<number>>;
  setDate: Dispatch<SetStateAction<string>>;
}

const ServiceEntryContext = createContext({});

const ServiceEntryProvider = (props: PropsWithChildren<{}>): ReactElement => {
  const serviceEntry = JSON.parse(getItem(LOCAL_STORAGE_SERVICE_ENTRY) ?? '{}');

  const [parkId, setParkId] = useState(serviceEntry.parkId ?? 0);
  const [date, setDate] = useState(serviceEntry.date ?? '');

  useEffect(() => {
    if (parkId || date) {
      setItem(
        LOCAL_STORAGE_SERVICE_ENTRY,
        JSON.stringify({
          parkId,
          date,
        }),
      );
    }
  }, [parkId, date]);

  const values: UseServiceEntry = {
    parkId,
    date,
    setParkId,
    setDate,
  };

  return <ServiceEntryContext.Provider value={values} {...props} />;
};

const useServiceEntry = (): UseServiceEntry =>
  useContext(ServiceEntryContext) as UseServiceEntry;

export { ServiceEntryProvider, useServiceEntry };
